<a
  class="skip-link"
  href="#main-content"
  (click)="skipToMain($event)"
  data-cy="skip-to-main">
  Skip to main content
</a>

<div
  class="app-container"
  utScreenSize>
  <mat-toolbar
    class="toolbar"
    [class.nav-open]="isMobileSidenavOpen()"
    data-cy="psu-toolbar">
    <!-- Toggle button is for handset (mobile) && portrait only -->
    @if (isHandsetAndPortrait() && !isMobileSearchVisible()) {
      <button
        type="button"
        mat-icon-button
        (click)="sidenav.toggle()"
        aria-label="Open Navigation Drawer"
        data-cy="open-nav-drawer-button">
        <mat-icon svgIcon="menu"></mat-icon>
      </button>
    }
    @if (!isHandsetAndPortrait() || (isHandsetAndPortrait() && !isMobileSearchVisible())) {
      <a
        class="psu-link"
        href="https://www.psu.edu/"
        utExternalLink
        aria-label="Penn State home page"
        data-cy="psu-header">
        <img
          class="toolbar-logo"
          [src]="logoPath() | psuCdn"
          alt="Penn State mark"
          data-cy="psu-logo" />
      </a>
    }
    @if (isNotHomeRoute$ | async) {
      <div
        class="search-bar-container"
        [class.visible]="isHandsetAndPortrait() && isMobileSearchVisible()">
        @if (isHandsetAndPortrait()) {
          <button
            mat-icon-button
            class="search-bar-toggle"
            [matTooltip]="isMobileSearchVisible() ? 'Close' : 'Open Search'"
            (click)="isMobileSearchVisible.set(!isMobileSearchVisible())"
            data-cy="open-searchbar-button">
            <mat-icon [svgIcon]="isMobileSearchVisible() ? 'close' : 'magnify'"></mat-icon>
          </button>
        }
        <div
          class="search-bar-component"
          [class.visible]="isHandsetAndPortrait() && isMobileSearchVisible()">
          <iwah-searchbar
            #searchbarComponent
            data-cy="searchbar"></iwah-searchbar>
        </div>
      </div>
    }
  </mat-toolbar>
  <mat-sidenav-container class="sidenav-container">
    <!-- Initialize to `opened` and `side` mode for >handset (mobile), `closed` and `over` for handset -->
    <mat-sidenav
      #sidenav
      class="sidenav"
      [mode]="isHandsetAndPortrait() ? 'over' : 'side'"
      [opened]="!isHandsetAndPortrait()"
      [disableClose]="!isHandsetAndPortrait()"
      (openedStart)="onSidenavOpenedStart()"
      (openedChange)="onSidenavOpenedChange($event)"
      data-cy="psu-sidenav">
      <div class="sidenav-spacing-wrapper">
        <!-- Toggle button is for handset (mobile) && portrait only -->
        @if (isHandsetAndPortrait()) {
          <div class="close-button-wrapper">
            <button
              type="button"
              mat-icon-button
              (click)="sidenav.toggle()"
              aria-label="Close Navigation Drawer"
              data-cy="close-nav-drawer-button">
              <mat-icon svgIcon="close"></mat-icon>
            </button>
          </div>
        }
        <mat-nav-list
          class="nav-list"
          disableRipple>
          <a
            mat-list-item
            #homeLink="routerLinkActive"
            class="nav-list-item"
            ariaCurrentWhenActive="page"
            routerLink=""
            routerLinkActive="link-active"
            [activated]="homeLink.isActive && isHandsetAndPortrait()"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="isHandsetAndPortrait() && sidenav.toggle()"
            data-cy="nav-home">
            <mat-icon
              matListItemIcon
              [svgIcon]="homeLink.isActive ? 'home' : 'home-outline'"></mat-icon>
            <span class="nav-list-item-link-title">Home</span>
          </a>
          <a
            mat-list-item
            #jobsLink="routerLinkActive"
            class="nav-list-item"
            ariaCurrentWhenActive="page"
            routerLink="/jobs"
            routerLinkActive="link-active"
            [activated]="jobsLink.isActive && isHandsetAndPortrait()"
            (click)="isHandsetAndPortrait() && sidenav.toggle()"
            data-cy="nav-jobs">
            <mat-icon
              matListItemIcon
              [svgIcon]="jobsLink.isActive ? 'cog-play' : 'cog-play-outline'"></mat-icon>
            <span class="nav-list-item-link-title">Jobs</span>
          </a>
          <a
            mat-list-item
            #forecastLink="routerLinkActive"
            class="nav-list-item"
            ariaCurrentWhenActive="page"
            routerLink="/forecast"
            routerLinkActive="link-active"
            [activated]="forecastLink.isActive && isHandsetAndPortrait()"
            (click)="isHandsetAndPortrait() && sidenav.toggle()"
            data-cy="nav-forecast">
            <mat-icon
              matListItemIcon
              [svgIcon]="forecastLink.isActive ? 'calendar-clock' : 'calendar-clock-outline'"></mat-icon>
            <span class="nav-list-item-link-title">Forecast</span>
          </a>
          <a
            mat-list-item
            #profilesLink="routerLinkActive"
            class="nav-list-item"
            ariaCurrentWhenActive="page"
            routerLink="/profiles"
            routerLinkActive="link-active"
            [activated]="profilesLink.isActive && isHandsetAndPortrait()"
            (click)="isHandsetAndPortrait() && sidenav.toggle()"
            data-cy="nav-profiles">
            <mat-icon
              matListItemIcon
              [svgIcon]="profilesLink.isActive ? 'account-group' : 'account-group-outline'"></mat-icon>
            <span class="nav-list-item-link-title">Profiles</span>
          </a>
          <a
            mat-list-item
            #validityLink="routerLinkActive"
            class="nav-list-item"
            ariaCurrentWhenActive="page"
            routerLink="/validity"
            routerLinkActive="link-active"
            [activated]="validityLink.isActive && isHandsetAndPortrait()"
            (click)="isHandsetAndPortrait() && sidenav.toggle()"
            data-cy="nav-validity">
            <mat-icon
              matListItemIcon
              [svgIcon]="validityLink.isActive ? 'alert-circle-check' : 'alert-circle-check-outline'"></mat-icon>
            <span class="nav-list-item-link-title">Validity</span>
          </a>
          @if (developmentFeatureRoutesEnabled) {
            <a
              mat-list-item
              #contactsLink="routerLinkActive"
              class="nav-list-item"
              ariaCurrentWhenActive="page"
              routerLink="/contacts"
              routerLinkActive="link-active"
              [activated]="contactsLink.isActive && isHandsetAndPortrait()"
              (click)="isHandsetAndPortrait() && sidenav.toggle()"
              data-cy="nav-contacts">
              <mat-icon
                matListItemIcon
                [svgIcon]="contactsLink.isActive ? 'contacts' : 'contacts-outline'"></mat-icon>
              <span class="nav-list-item-link-title">Contacts</span>
            </a>
            <a
              mat-list-item
              #inventoryLink="routerLinkActive"
              class="nav-list-item"
              ariaCurrentWhenActive="page"
              routerLink="/inventory"
              routerLinkActive="link-active"
              [activated]="inventoryLink.isActive && isHandsetAndPortrait()"
              (click)="isHandsetAndPortrait() && sidenav.toggle()"
              data-cy="nav-inventory">
              <mat-icon
                matListItemIcon
                [svgIcon]="inventoryLink.isActive ? 'list-box' : 'list-box-outline'"></mat-icon>
              <span class="nav-list-item-link-title">Inventory</span>
            </a>
          }
        </mat-nav-list>
        <div class="theme-toggle-container">
          @if (isHandsetAndPortrait()) {
            <button
              class="theme-switcher-button"
              type="button"
              mat-button
              [matMenuTriggerFor]="themeMenu"
              data-cy="toggle-theme-button"
              [attr.aria-label]="'Theme: ' + themeLabel() + '. Click to change theme.'">
              <mat-icon [svgIcon]="themeIcon()"></mat-icon>
              {{ themeLabel() }}
            </button>
          } @else {
            <button
              type="button"
              mat-icon-button
              [matMenuTriggerFor]="themeMenu"
              [matTooltip]="'Theme: ' + themeLabel()"
              matTooltipPosition="after"
              [attr.aria-label]="'Theme: ' + themeLabel() + '. Click to change theme.'"
              data-cy="toggle-theme-button">
              <mat-icon [svgIcon]="themeIcon()"></mat-icon>
            </button>
          }
          <mat-menu #themeMenu="matMenu">
            <button
              mat-menu-item
              type="button"
              (click)="setTheme('light')"
              [attr.aria-current]="themeMode() === 'light' ? 'true' : null">
              <mat-icon svgIcon="white-balance-sunny"></mat-icon>
              <span class="theme-menu-item-label">
                Light
                @if (themeMode() === 'light') {
                  <mat-icon
                    class="selected-indicator"
                    svgIcon="check"></mat-icon>
                }
              </span>
            </button>
            <button
              mat-menu-item
              type="button"
              (click)="setTheme('dark')"
              [attr.aria-current]="themeMode() === 'dark' ? 'true' : null">
              <mat-icon svgIcon="weather-night"></mat-icon>
              <span class="theme-menu-item-label">
                Dark
                @if (themeMode() === 'dark') {
                  <mat-icon
                    class="selected-indicator"
                    svgIcon="check"></mat-icon>
                }
              </span>
            </button>
            <button
              mat-menu-item
              type="button"
              (click)="setTheme('auto')"
              [attr.aria-current]="themeMode() === 'auto' ? 'true' : null">
              <mat-icon svgIcon="theme-light-dark"></mat-icon>
              <span class="theme-menu-item-label">
                Auto
                @if (themeMode() === 'auto') {
                  <mat-icon
                    class="selected-indicator"
                    svgIcon="check"></mat-icon>
                }
              </span>
            </button>
          </mat-menu>
        </div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content class="content">
      <main
        #mainContentArea
        id="main-content"
        tabindex="-1"
        cdkVirtualScrollingElement>
        <router-outlet />
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
